/* ====================================================================
   FLOOREVER — RECHERCHE (sections/floorever-header.liquid : <dialog>)
   Vanilla JS, defer, aucune dépendance.

   - Loupe du header et lien « Rechercher » du menu mobile : SANS JS,
     liens directs vers /search ; avec JS, ouverture d'un <dialog>
     modal (scroll lock Skeleton via l'attribut scroll-lock, Échap
     natif, clic sur le fond = fermeture — conventions du drawer).
   - Saisie : dès 2 caractères, appel debouncé (250 ms) de l'API
     prédictive Shopify (produits seulement, 6 max, indisponibles
     cachés), requête précédente annulée (AbortController) + garde
     anti-réponse périmée.
   - Suggestions rendues par LIQUID (Section Rendering API :
     /search/suggest?q=…&section_id=floorever-suggest), le <ul> de
     sections/floorever-suggest.liquid est injecté tel quel — même
     principe que le drawer, zéro template JS. C'est ce qui permet
     de discriminer les gammes d'un même décor (metafield
     custom.gamme + prix mini hors variantes à 0 €), ce que le
     JSON /search/suggest.json ne sait pas faire (4 lignes « FE312 »
     identiques, prix = 0,00 € l'échantillon).
   - Entrée = submit natif du form GET /search?q=… (bloqué seulement
     si le champ est vide) ; « Tous les résultats » suit la saisie.
   ==================================================================== */
(function () {
  'use strict';

  function init() {
    var dialog = document.querySelector('[data-recherche]');
    if (!dialog || dialog.dataset.rechercheInit === 'true') return;
    if (typeof dialog.showModal !== 'function') return; /* repli : lien /search */
    dialog.dataset.rechercheInit = 'true';

    var input = dialog.querySelector('[data-recherche-input]');
    var form = input && input.form;
    if (!input || !form) return;

    var defaut = dialog.querySelector('[data-recherche-defaut]');
    var resultats = dialog.querySelector('[data-recherche-resultats]');
    var liste = dialog.querySelector('[data-recherche-liste]');
    var lienTout = dialog.querySelector('[data-recherche-tout]');
    var vide = dialog.querySelector('[data-recherche-vide]');
    var terme = dialog.querySelector('[data-recherche-terme]');
    var statut = dialog.querySelector('[data-recherche-statut]');
    var urlSuggest = dialog.dataset.urlSuggest || '/search/suggest';
    var urlSearch = form.getAttribute('action') || '/search';

    var minuteur = null;
    var controleur = null;

    /* ---- états d'affichage : 'defaut' | 'resultats' | 'vide' ---- */
    function afficher(etat) {
      if (defaut) defaut.hidden = etat !== 'defaut';
      if (resultats) resultats.hidden = etat !== 'resultats';
      if (vide) vide.hidden = etat !== 'vide';
    }

    function annoncer(texte) {
      if (statut) statut.textContent = texte;
    }

    /* ---- API prédictive (rendu Liquid : sections/floorever-suggest) ---- */
    function chercher(q) {
      if (controleur) controleur.abort();
      controleur = typeof AbortController === 'function' ? new AbortController() : null;
      var url = urlSuggest + '?q=' + encodeURIComponent(q) +
        '&section_id=floorever-suggest' +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide';
      fetch(url, { signal: controleur && controleur.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          if (q !== input.value.trim()) return; /* réponse périmée */
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nouveau = doc.querySelector('[data-suggest-liste]');
          var lignes = nouveau ? nouveau.querySelectorAll('li') : [];
          liste.textContent = '';
          for (var i = 0; i < lignes.length; i++) liste.appendChild(lignes[i]);
          if (lienTout) {
            lienTout.href = urlSearch + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
          }
          if (lignes.length) {
            afficher('resultats');
            annoncer(lignes.length + ' suggestion' + (lignes.length > 1 ? 's' : ''));
          } else {
            if (terme) terme.textContent = q;
            afficher('vide');
            annoncer('Aucun résultat');
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          afficher('defaut'); /* API muette : Entrée mène toujours à /search */
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (minuteur) clearTimeout(minuteur);
      if (q.length < 2) {
        afficher('defaut');
        annoncer('');
        return;
      }
      minuteur = setTimeout(function () { chercher(q); }, 250);
    });

    form.addEventListener('submit', function (e) {
      if (input.value.trim() === '') e.preventDefault();
    });

    /* Flèche bas : du champ vers la première suggestion */
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' || !resultats || resultats.hidden) return;
      var premier = liste.querySelector('a');
      if (premier) {
        e.preventDefault();
        premier.focus();
      }
    });

    /* ---- ouverture / fermeture ---- */
    /* Ouvert depuis le panneau burger, le lien déclencheur disparaît avec le
       panneau : à la fermeture, le focus revient sur le bouton du menu. */
    var retour = null;
    dialog.addEventListener('close', function () {
      if (retour) {
        retour.focus();
        retour = null;
      }
    });

    function ouvrir() {
      var burger = document.querySelector('.header-burger[open]');
      retour = null;
      if (burger) {
        burger.removeAttribute('open'); /* le dialog passe devant */
        retour = burger.querySelector('summary');
      }
      if (!dialog.open) dialog.showModal();
      input.focus();
      input.select();
    }

    document.addEventListener('click', function (e) {
      var declencheur = e.target.closest('[data-recherche-ouvrir]');
      if (declencheur) {
        e.preventDefault();
        ouvrir();
      }
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) {
        dialog.close();
        return;
      }
      if (e.target.closest('[data-recherche-fermer]')) dialog.close();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
